/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   ProConData Bizo
 */

import type { ProConData as ProConDataType, RawProConData } from '@zcode/state-type'
import { Bizo, autoclass } from '../../shared/bizos/base'

const DEFINITION = {
  pros: 'pros',
  cons: 'cons',
} as const

export const ProConData = autoclass<ProConDataType, RawProConData>(
  'ProConData',
  class ProConData extends Bizo<ProConDataType, RawProConData> {},
  DEFINITION,
  null
)
